import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import countries from './Countries';
import './CountryInputHome.css';

function CountryInputHome() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const dropdownRef = useRef();
  const navigate = useNavigate();

  // Filter countries based on search term
  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
    setHighlightedIndex(0);
  };

  const handleOptionClick = (country) => {
    setSearchTerm(country.name);
    setShowDropdown(false);
    // Navigate directly to the country route
    navigate(`/courts/${country.name.toLowerCase()}`);
  };

  const handleKeyDown = (e) => {
    if (!showDropdown || filteredCountries.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex((prevIndex) =>
        prevIndex === filteredCountries.length - 1 ? 0 : prevIndex + 1
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex((prevIndex) =>
        prevIndex === 0 ? filteredCountries.length - 1 : prevIndex - 1
      );
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const selectedCountry = filteredCountries[highlightedIndex];
      if (selectedCountry) {
        handleOptionClick(selectedCountry);
      }
    } else if (e.key === 'Escape') {
      setShowDropdown(false);
    }
  };

  return (
    <div className="country-input-home" ref={dropdownRef}>
      <input
        className="country-input-field"

        type="text"
        name="country"
        value={searchTerm}
        onChange={handleInputChange}
        onClick={() => setShowDropdown(true)}
        onKeyDown={handleKeyDown}
        placeholder="Search for a country"
      />
      {showDropdown && (
        <ul className="country-dropdown">
          {filteredCountries.length > 0 ? (
            filteredCountries.map((country, index) => (
              <li
                key={country.code}
                onClick={() => handleOptionClick(country)}
                className={`country-option ${index === highlightedIndex ? 'highlighted' : ''}`}
              >
                <span className="country-flag">{country.flag}</span>
                {country.name}
              </li>
            ))
          ) : (
            <li className="country-option">No matches found</li>
          )}
        </ul>
      )}
    </div>
  );
}

export default CountryInputHome;